import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import { getFromLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/getFromLocalStorageWithExpiry'
import { getlbUserId, createLastBrandUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import { setInLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/setInLocalStorageWithExpiry'
import { createNewSession, getSessionId } from '@src/utils/user/session.browser'

export const validateLbUserId = () => {
  let lbUserId = getlbUserId()
  if (!lbUserId) {
    createLastBrandUserId() // Create if needed.
    lbUserId = getlbUserId()
  }
  if (lbUserId && !getFromLocalStorageWithExpiry(ANALYTIC_COOKIES.LB_USER_ID, false)) {
    setInLocalStorageWithExpiry(ANALYTIC_COOKIES.LB_USER_ID, lbUserId)
  }
  return lbUserId
}

let isNewSession = false
const lastSessionIdKey = 'last_session_id'
let lastSessionId: string | null = null

export const validateSessionId = () => {
  let sessionIdFromCookie = getSessionId()
  if (!sessionIdFromCookie) {
    createNewSession()
  }
  sessionIdFromCookie = getSessionId()
  if (!sessionIdFromCookie) {
    return null
  }
  // eslint-disable-next-line @quince/no-direct-localstorage
  const lastSessionIdFromLocalStorage = localStorage.getItem(lastSessionIdKey)
  if (lastSessionIdFromLocalStorage !== sessionIdFromCookie) {
    lastSessionId = lastSessionIdFromLocalStorage
    isNewSession = true
  }
  // eslint-disable-next-line @quince/no-direct-localstorage
  localStorage.setItem(lastSessionIdKey, sessionIdFromCookie)
  setInLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID, sessionIdFromCookie, 120)
  return sessionIdFromCookie
}

export const executeOnceIfSessionIsNew = (
  task: (data: { sessionId: string; lastSessionId?: string | null }) => void,
) => {
  if (isNewSession) {
    isNewSession = false
    try {
      task({ sessionId: getSessionId() ?? '', lastSessionId })
    } catch (error) {
      console.error('Error executing task for new session:', error)
    }
  }
}
